import { Controller } from "@hotwired/stimulus"
// data-controller="telemetry_status"
export default class extends Controller {
  static targets = ["badge"]
  static values = { url: String, interval: { type: Number, default: 5000 } }
  connect() { this._tick(); this.timer = setInterval(() => this._tick(), this.intervalValue) }
  disconnect() { if (this.timer) clearInterval(this.timer) }
  async _tick() {
    if (!this.hasUrlValue) return
    try {
      const res = await fetch(this.urlValue, { headers: { "Accept": "application/json" } })
      if (!res.ok) return
      const j = await res.json()

      const statusMap = {
        synced: { color: "#22c55e", title: "Connecté" },
        pending: { color: "#f59e0b", title: "En attente..." },
        error: { color: "#ef4444", title: "Erreur" },
        unknown: { color: "#6b7280", title: "Non configuré" }
      }

      const config = statusMap[j.status] || statusMap.unknown

      this.badgeTarget.innerHTML = `
        <span style="display: block; width: 14px; height: 14px; background-color: ${config.color}; border-radius: 50%; border: 2px solid var(--ki-surface); box-shadow: 0 0 0 1px var(--ki-border);" title="${config.title} • ${j.last_error || ''}"></span>
      `
    } catch (_e) { }
  }
}
